var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { autoinject, transient } from "aurelia-framework";
import { Router } from "aurelia-router";
import { I18N } from "aurelia-i18n";
import { EventAggregator } from "aurelia-event-aggregator";
import { EntityValidationsService } from "../../../client-validation-system/validations-service";
import { NotificationClientService, NotificationType } from "../../../services/basics/notification-client.service";
import { ValidationActivation, ValidationTypeEnum } from "../../../client-validation-system/validations.models";
import { TokenClient } from "../../../services/authentication/token-client.service";
var ChangePasswordViewModel = /** @class */ (function () {
    function ChangePasswordViewModel(userClient, router, i18N, entityValidationsService, notificationService, eventAggregator) {
        this.userClient = userClient;
        this.router = router;
        this.i18N = i18N;
        this.entityValidationsService = entityValidationsService;
        this.notificationService = notificationService;
        this.eventAggregator = eventAggregator;
    }
    ChangePasswordViewModel.prototype.activate = function (params) {
        this.token = params.token;
    };
    ChangePasswordViewModel.prototype.attached = function () {
        var rulesHolder = {
            activation: ValidationActivation.Always,
            entityName: this.i18N.tr('login-text'),
            isCollection: false,
            nestedRulesHolder: [],
            rules: [{
                    errorMessage: this.i18N.tr('current-password-required-text'),
                    parameters: null, property: "currentPassword",
                    validationType: ValidationTypeEnum.Required
                }, {
                    errorMessage: this.i18N.tr('new-password-required-text'),
                    parameters: null, property: "newPassword",
                    validationType: ValidationTypeEnum.Required
                }, {
                    errorMessage: this.i18N.tr('confirm-new-password-required-text'),
                    parameters: null, property: "confirmNewPassword",
                    validationType: ValidationTypeEnum.Required
                }]
        };
        this.eventAggregator.publish('set-header', { backTitle: this.i18N.tr('change-password-text'), class: '' });
        this.validator = this.entityValidationsService.getValidator(this, rulesHolder);
    };
    ChangePasswordViewModel.prototype.save = function () {
        var _this = this;
        this.submitting = true;
        this.validator.validate().then(function (x) {
            if (x.valid) {
                var request = {
                    currentPassword: _this.currentPassword,
                    newPassword: _this.newPassword,
                    confirmNewPassword: _this.confirmNewPassword,
                    token: _this.token
                };
                _this.userClient.changePassword(request).then(function (x) {
                    _this.notificationService.show(_this.i18N.tr('password-changed-successfully-text'), "", NotificationType.Success);
                    if (_this.token) {
                        _this.router.navigateToRoute("login", { replace: true });
                    }
                    else {
                        _this.router.navigate("/", { replace: true });
                    }
                    _this.submitting = false;
                }).catch(function (exception) {
                    _this.submitting = false;
                    if (exception._content && exception._content.key == "password-invalid") {
                        var meta = exception._content.meta;
                        var passwordInvalidMessage = "";
                        if (!meta.satisfiesMinimumLength) {
                            passwordInvalidMessage += "Password must be long at least ".concat(meta.userPasswordPolicy.minimumLength, " characters.\n");
                        }
                        if (!meta.satisfiesMinimumNumberOfDigits) {
                            passwordInvalidMessage += "Password must have at least ".concat(meta.userPasswordPolicy.minimumNumberOfDigits, " digits.\n");
                        }
                        if (!meta.satisfiesMinimumNumberSpecialCharacters) {
                            passwordInvalidMessage += "Password must have at least ".concat(meta.userPasswordPolicy.minimumNumberSpecialCharacters, " special characters.\n");
                        }
                        _this.notificationService.show("Invalid password", passwordInvalidMessage, NotificationType.Error, 5000);
                    }
                    else {
                        _this.notificationService.show(exception._content.details ? exception._content.details : _this.i18N.tr('user-cannot-be-saved-text'), "", NotificationType.Error, 5000);
                    }
                });
            }
            _this.submitting = false;
        });
    };
    ChangePasswordViewModel = __decorate([
        autoinject,
        transient(),
        __metadata("design:paramtypes", [TokenClient,
            Router,
            I18N,
            EntityValidationsService,
            NotificationClientService,
            EventAggregator])
    ], ChangePasswordViewModel);
    return ChangePasswordViewModel;
}());
export { ChangePasswordViewModel };
